module.exports = __webpack_public_path__ + "img/material-trading.1c43c464.svg";